import axios from 'axios';
import helpers from '@/helpers';
import store from './store/store';

const server_api_url = process.env.NODE_ENV === 'local' ? 'http://localhost:3000' : 'http://89.108.64.158:3000';
let axiosConfig = new Object();

axiosConfig.server_api_url = server_api_url;

// common setting
const instance = axios.create({
  baseURL: server_api_url,
  headers: {
    Authorization: {
      toString () {
        return `JWT ${localStorage.getItem('jwtToken')}`;
      }
    }
  }
});
const instanceFD = axios.create({
  baseURL: server_api_url,
  headers: {
    Authorization: {
      toString () {
        return `JWT ${localStorage.getItem('jwtToken')}`;
      }
    },
    'Content-Type': 'multipart/form-data'
  }
});

instance.interceptors.request.use(config => {
  store.dispatch('loadStart');
  return config;
});

instance.interceptors.response.use(response => {
  store.dispatch('loadDone');
  return response;
},
function (error) {
  store.dispatch('loadDone');
  return Promise.reject(error);
}
);

// counstructors
axiosConfig.get = async (url, params) => {
  // console.log(params)
  let result = await instance({
    method: 'get',
    url: url,
    params: params
  });
  return result;
};

axiosConfig.patch = async (url, data, params) => {
  let result = await instance({
    method: 'patch',
    url: url,
    data: data,
    params: params
  });
  return result;
};

axiosConfig.patchFD = async (url, image, params) => {
  var formDataToUpload = new FormData();

  if (image && image.dataUrl) {
    let blob = await helpers.files.dataURItoBlob(image.dataUrl);
    formDataToUpload.append('image', blob);
  }

  let result = await instanceFD({
    method: 'patch',
    url,
    data: formDataToUpload,
    params
  });
  return result;
};

axiosConfig.postFD = async (url, image, params) => {
  var formDataToUpload = new FormData();

  if (image && image.dataUrl) {
    let blob = await helpers.files.dataURItoBlob(image.dataUrl);
    formDataToUpload.append('image', blob);
  }

  let result = await instanceFD({
    method: 'post',
    url,
    data: formDataToUpload,
    params
  });
  return result;
};

axiosConfig.post = async (url, data, params) => {
  let result = await instance({
    method: 'post',
    url,
    data,
    params
  });
  return result;
};

axiosConfig.delete = async (url, data, params) => {
  let result = await instance({
    method: 'delete',
    url: url,
    data: data,
    params: params
  });
  return result;
};

axiosConfig.error = (err) => {
  let message;
  let status;
  if (err.response) {
    message = err.response.data.message;
    console.log(err.response.data);
    console.log(err.response.status);
    status = err.response.status;
    console.log(err.response.headers);
  } else if (err.request) {
    console.log(err.request);
  } else {
    console.log('Error', err.message);
  }
  console.log(err.config);
  let statusStr = helpers.error.getStatusStr(status);
  let messageStr = helpers.error.getErrorStr(message);
  if (statusStr) return statusStr;
  return messageStr;
};

export default axiosConfig;